import React from 'react';
import { Alert, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import HoverableTag from '../HoverableTag';

const QueryDeepResearchExplainer = ({ onExampleClick }) => {
  const { t } = useTranslation();

  const handleExampleClick = (example) => {
    if (onExampleClick) {
      onExampleClick(example);
    }
  };

  return (
    <Alert
      style={{ 
        marginTop: '8px',
        backgroundColor: '#fefcff',
        borderColor: '#e6d9ff',
        border: '1px solid #e6d9ff'
      }}
      description={
        <div>
          <div>
            {(() => {
              const examples = t('query_deep_research.examples', { returnObjects: true });
              return Array.isArray(examples) ? examples.map((example, index) => (
                <div key={index} style={{ marginBottom: '20px' }}>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#1a1a1a'
                  }}>
                    <span style={{ marginRight: '8px', fontSize: '18px' }}>{example.role.split(' ')[0]}</span>
                    <span>{example.role.split(' ').slice(1).join(' ')}</span>
                  </div>
                  <div style={{ 
                    color: '#1a1a1a', 
                    marginBottom: '10px', 
                    fontSize: '15px',
                    lineHeight: '1.5',
                    fontWeight: '400'
                  }}>
                    {example.use_case}
                  </div>
                  <Row gutter={[16, 8]}>
                    <Col xs={24}>
                      <HoverableTag
                        text={example.example}
                        onClick={() => handleExampleClick(example.example)}
                        highlight={true}
                        style={{ 
                          fontSize: '14px',
                          padding: '8px 16px',
                          borderRadius: '20px',
                          height: 'auto',
                          minHeight: '40px',
                          lineHeight: '1.4',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          cursor: 'pointer'
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              )) : null;
            })()}
          </div>
        </div>
      }
    />
  );
};

export default QueryDeepResearchExplainer; 